<template lang="html">
  <div
    :class="resource.columns.container ? 'container' : null"
    class="team-photo"
  >
    <Media :path="resource.columns.media.path" :container="false" />
    <div class="team-photo__caption-container">
      <TeamPhotoItem v-for="child in member" :key="child.id" :resource="child" />
    </div>
  </div>
</template>

<script>
import { sortBy } from 'lodash'
import TeamPhotoItem from 'beisheim/components/blocks/team-photo-item'
import Media from 'beisheim/components/elements/media'
import editable from '@i22/frontend-cms-utils/mixins/editable'

export default {
  components: {
    Media,
    TeamPhotoItem
  },
  mixins: [editable],
  computed: {
    children () {
      console.dir({
        TeamPhotoResoure: this.resource,
        TeamPhotoResoureChildren: this.resource.children,
      }, { depth: 8 })
      return sortBy(this.resource.children, 'sort_key')
    },
    member () {
      console.dir({
        TeamPhotoResoure: this.resource,
        TeamPhotoResoureMember: this.resource.member,
      }, { depth: 8 })
      return sortBy(this.resource.member, 'sort_key')
    }
  }
}
</script>

<style lang="scss">
  @import '~beisheim/scss/scale';
  @import '~beisheim/scss/fluid-type';
  @import '~beisheim/scss/grid';
  @import '~beisheim/scss/breakpoints';
  @import '~beisheim/scss/font';
  @import '~beisheim/scss/link';

  .team-photo {
    margin-top: scale(10);
    margin-bottom: scale(10);

    &__caption-container {
      display: flex;
      justify-content: space-between;
      padding: scale(4) scale(6);

      @include to(3) {
        flex-direction: column;
      }
    }

    &__caption {
      padding: scale(1) 0;
      font-size: font-size(0);

      a, span {
        @include link;
        padding: 0;
        font-size: font-size(0);

        @include from(4) {
          font-size: font-size(-1);
        }

        @include from(5) {
          font-size: font-size(0);
        }
      }

      @include from(4) {
        padding: 0 scale(2);
        flex: 1;
      }
    }
  }

</style>
